

















import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  name: 'Steps',
  props: {
    active: {
      type: String,
      default: '1',
    },
    stepArray: {
      type: Array,
      defalut: []
    },
    width: {
      type: Number,
      defalut: 300,
    },
    height: {
      type: Number,
      defalut: 100
    }
  },
  setup( props: any) {
    const { width, stepArray } = props;
    const singleWidth = ref(width/(stepArray.length));
    
    return {
      singleWidth
    };
  },
});
